export interface IScheduleBlockTypeModel {
  scheduleBlockTypeId: number;
  name: string;
  color: string;
  isOverrideType: boolean;
  showOverrideNotesOnCalendar: boolean;
}

export class ScheduleBlockTypeModel implements IScheduleBlockTypeModel {
  scheduleBlockTypeId: number;
  name: string;
  color: string;
  isOverrideType: boolean;
  showOverrideNotesOnCalendar: boolean;

  constructor(
    params: Partial<ScheduleBlockTypeModel> = {} as ScheduleBlockTypeModel,
  ) {
    const {
      scheduleBlockTypeId = 0,
      name = '',
      color = '',
      isOverrideType = false,
      showOverrideNotesOnCalendar = false,
    } = params;

    this.scheduleBlockTypeId = scheduleBlockTypeId;
    this.name = name;
    this.color = color;
    this.isOverrideType = isOverrideType;
    this.showOverrideNotesOnCalendar = showOverrideNotesOnCalendar;
  }
}

export interface IScheduleBlockTypeUIModel extends IScheduleBlockTypeModel {
  isDisabled?: boolean;
}

export class ScheduleBlockTypeUIModel extends ScheduleBlockTypeModel {
  isDisabled?: boolean = false;

  constructor(params: Partial<IScheduleBlockTypeUIModel>) {
    super(params);
    this.isDisabled = params.isDisabled;
  }
}
